import colors from "./colors";

import pxToRem from "../functions/pxToRem";

const { text } = colors;

const baseProperties = {
  fontFamily: '"Segoe UI Variable Text", "Segoe UI Variable", "Segoe UI", system-ui, -apple-system, "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  fontWeightLighter: 200,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  fontWeightExtraBold: 700,
  fontSizeXXS: pxToRem(10),
  fontSizeXS: pxToRem(12),
  fontSizeSM: pxToRem(13),
  fontSizeMD: pxToRem(14),
  fontSizeLG: pxToRem(16),
  fontSizeXL: pxToRem(18),
  fontSize2XL: pxToRem(22),
  fontSize3XL: pxToRem(28),
};

const baseHeadingProperties = {
  fontFamily: baseProperties.fontFamily,
  color: text.primary,
  fontWeight: baseProperties.fontWeightBold,
  letterSpacing: "-0.01em",
};

const baseDisplayProperties = {
  fontFamily: baseProperties.fontFamily,
  color: text.primary,
  fontWeight: baseProperties.fontWeightBold,
  lineHeight: 1.2,
  letterSpacing: "-0.015em",
};

const typography = {
  fontFamily: baseProperties.fontFamily,
  fontWeightLighter: baseProperties.fontWeightLighter,
  fontWeightLight: baseProperties.fontWeightLight,
  fontWeightRegular: baseProperties.fontWeightRegular,
  fontWeightMedium: baseProperties.fontWeightMedium,
  fontWeightBold: baseProperties.fontWeightBold,

  h1: {
    ...baseDisplayProperties,
    fontSize: pxToRem(32),
    lineHeight: 1.25,
  },

  h2: {
    ...baseDisplayProperties,
    fontSize: pxToRem(26),
    lineHeight: 1.3,
  },

  h3: {
    ...baseHeadingProperties,
    fontSize: pxToRem(22),
    lineHeight: 1.35,
  },

  h4: {
    ...baseHeadingProperties,
    fontSize: pxToRem(18),
    lineHeight: 1.4,
  },

  h5: {
    ...baseHeadingProperties,
    fontSize: pxToRem(16),
    lineHeight: 1.45,
  },

  h6: {
    ...baseHeadingProperties,
    fontSize: pxToRem(14),
    lineHeight: 1.5,
  },

  subtitle1: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeLG,
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.5,
    color: text.primary,
  },

  subtitle2: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeMD,
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.5,
    color: text.secondary,
  },

  body1: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeMD,
    fontWeight: baseProperties.fontWeightRegular,
    lineHeight: 1.6,
    color: text.primary,
  },

  body2: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeSM,
    fontWeight: baseProperties.fontWeightRegular,
    lineHeight: 1.6,
    color: text.secondary,
  },

  button: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeSM,
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.5,
    textTransform: "none" as const,
    letterSpacing: "0",
  },

  caption: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeXS,
    fontWeight: baseProperties.fontWeightRegular,
    lineHeight: 1.5,
    color: text.secondary,
  },

  overline: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeXXS,
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.5,
    textTransform: "uppercase" as const,
    letterSpacing: "0.08em",
    color: text.secondary,
  },

  size: {
    xxs: baseProperties.fontSizeXXS,
    xs: baseProperties.fontSizeXS,
    sm: baseProperties.fontSizeSM,
    md: baseProperties.fontSizeMD,
    lg: baseProperties.fontSizeLG,
    xl: baseProperties.fontSizeXL,
    "2xl": baseProperties.fontSize2XL,
    "3xl": baseProperties.fontSize3XL,
  },

  lineHeight: {
    sm: 1.25,
    md: 1.5,
    lg: 1.75,
  },
};

export default typography;
